<template>
    <Trombinoscope 
    Title="Graphisme" 
    :projects="graphicProjects"
    baseRoute="/portfolio/graphisme"
    />
</template>






<script>


import Trombinoscope from '@/components/Trombinoscope.vue';




export default {
  components:{
    Trombinoscope
  },
  data() {
    return {
      graphicProjects: [
      {
          nom: 'Gyökeres',
          description: "Affiche sur Viktor Gyökeres",
          background: '/img/projet/gyokeres.jpg',
          skills:['photoshop.png'],
          date:"Novembre 2024"
        },
        { 
          nom: 'Barcola',
           description: 'Affiche sur Bradley Barcola', 
           background: '/img/projet/barcola.jpg' ,
           skills:['photoshop.png'],
           date:"Août 2024"
          },
          { 
          nom: 'Vitinha',
           description: 'Affiche sur Vitinha', 
           background: '/img/projet/vitinha.jpg',
           skills:['photoshop.png'],
           date:"Novembre 2024"
          },
          {
          nom: 'Vitinha 2.0',
           description: 'Double éclairage sur Vitinha', 
           background: '/img/projet/vitinha2.jpg',
           skills:['photoshop.png'],
           date:"Novembre 2024"
          },
          { 
          nom: 'João Neves',
           description: 'Affiche sur João Neves', 
           background: '/img/projet/joaoNeves.jpg',
           skills:['photoshop.png'],
           date:"Août 2024"
          },
          { 
          nom: 'Shanks',
           description: 'Affiche sur Shanks de One Piece', 
           background: '/img/projet/shanks.jpg',
           skills:['photoshop.png'] ,
           date:"Mars 2024"
          },
          // { 
          // nom: 'Mbappé',
          //  description: 'Affiche sur Kylian Mbappé', 
          //  background: '/img/projet/kylian.jpg',
          //  skills:['photoshop.png'],
          //  date:"Octobre 2024"
          // },
          // { 
          // nom: 'Cartel',
          //  description: 'Affiche inspirée des cartels de la drogue sud-américains', 
          //  background: '/img/projet/cartel.jpg',
          //  skills:['photoshop.png'],
          //  date:"Octobre 2024" 
          // },
          {
          nom: 'JME',
           description: 'Affiche pour promouvoir la journée mondiale de l"eau', 
           background: '/img/projet/JME.jpg',
           skills:['photoshop.png'],
           date:"Novembre 2023"
          },
          {
          nom: 'Limites planétaires',
           description: 'Affiche sur les limites planétaires', 
           background: '/img/projet/limitesPlanetaires.jpg',
           skills:['illustrator.png'],
           date:"Avril 2024"
          },
          { 
          nom: 'Festival',
           description: 'Affiche pour une campagne de festival pour la jeunesse européenne', 
           background: '/img/projet/festival.jpg',
           skills:['photoshop.png'],
           date:"Juin 2024"
          },
          {
          nom: 'Auto-Portrait',
           description: 'Auto-Portrait', 
           background: '/img/projet/autoPortrait.jpg',
           skills:['illustrator.png'],
           date:"Novembre 2023"
          },
          {
           nom: 'Lame secrète',
           description: 'Téléphone lame secrète', 
           background: '/img/projet/lameSecrete.jpg',
           skills:['photoshop.png'],
           date:"Décembre 2023"
          },
          { 
          nom: 'Campagne publicitaire',
           description: "Affiche campagne publicitaire contre l'étalement urbain",
           background: '/img/projet/campagnePublicitaire.jpg',
           skills:['photoshop.png'],
           date:"Décembre 2024"
          },
          { 
          nom: 'Sapik',
           description: "Remodernisation d'une marque de  piment fictive",
           background: '/img/projet/sapik.jpg',
           skills:['photoshop.png','canva.png'],
           date:"Mars 2025"
          },
          {
          nom: 'Infographie animée',
           description: "Infographie animée sur le thème de la difficulté",
           background: '/img/projet/infographie.jpg',
           skills:['illustrator.png','animate.png'],
           date:"Janvier 2025"
          },
          { 
          nom: 'PSG - City',
           description: "Affiche d'avant match PSG - Manchester City",
           background: '/img/projet/psg-city.jpg',
           skills:['photoshop.png'],
           date:"Janvier 2025"
          },
          { 
          nom: 'Mbappé',
           description: "Affiche sur Kylian Mbappé",
           background: '/img/projet/kylian2.jpg',
           skills:['photoshop.png'],
           date:"Août 2024"
          },
          {
          nom: 'Matchday',
           description: "Jour de match du PSG",
           background: '/img/projet/matchday.jpg',
           skills:['photoshop.png'],
           date:"Août 2024"
          },
          { 
          nom: 'Kvaratskhelia',
           description: "Entrainement au light avec Kvaratskhelia",
           background: '/img/projet/kvaratskhelia.png',
           skills:['photoshop.png'],
           date:"Février 2025"
          },
          {
          nom: 'Kvaratskhelia 2',
           description: "Entrainement au light avec Kvaratskhelia",
           background: '/img/projet/kvaratskhelia2.jpg',
           skills:['photoshop.png'],
           date:"Février 2025"
          },
          { 
          nom: 'Kvaratskhelia 3',
           description: "Affiche sur Khvicha Kvaratskhelia",
           background: '/img/projet/kvaratskhelia3.jpg',
           skills:['photoshop.png'],
           date:"Février 2025"
          },
          { 
          nom: 'Bannière',
           description: "Bannière LinkedIn",
           background: '/img/projet/banniere.jpg',
           skills:['canva.png'],
           date:"Mai 2025"
          },
          {
        nom: 'Quantum stagiaire',
        description: "Affiche promotionnelle pour un poste de stagiaire chargé(e) de communication chez Quantum",
        background: '/img/projet/stagiaire.jpg',
        skills: ['photoshop.png'],
        date: "Mai 2025"
      },
      {
        nom: 'Golden Boy',
        description: "Affiche sur Désiré Doué",
        background: '/img/projet/doue.jpg',
        skills: ['photoshop.png'],
        date: "Juillet 2025"
      },
      {
        nom: 'Effet Vintage',
        description: "Effet vintage sur une photo de moi",
        background: '/img/projet/oldPicture.jpg',
        skills: ['photoshop.png'],
        date: "Mars 2025"
      }
      ],
    };
  },
};


</script>




<style scoped>

</style>